const serverUrl = process.env.REACT_APP_SERVER_URL;

export const loginUrl = `${serverUrl}/login/`;
export const signupUrl = `${serverUrl}/signup/`;
export const itemsUrl = `${serverUrl}/items`;
export const taxesUrl = `${serverUrl}/taxes`;
export const paymentMethodsUrl = `${serverUrl}/paymentMethods`;
